import {} from '@angular/common/http';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { AuthService } from './services/auth/auth.service';
import { ChatService } from './services/chat/chat.service';
import { Router, RouterModule } from '@angular/router';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { AlarmService } from './services/alarm.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterModule, DialogModule, ButtonModule],
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit, OnDestroy {
  private isConnectionInitialized = false;

  private primengConfig = inject(PrimeNGConfig);
  private authService = inject(AuthService);
  private chatService = inject(ChatService);
  public alarmService = inject(AlarmService);
  public router = inject(Router);
  private subscription = new Subscription();
  constructor() {}

  ngOnInit() {
    this.primengConfig.ripple = true;
    const user = JSON.parse(localStorage.getItem('auth')!);
    if (user) {
      this.subscription.add(
        this.authService.getUserByUsername(user.username).subscribe((user) => {
          if (!this.isConnectionInitialized) {
            this.isConnectionInitialized = true;
          }
        })
      );
    }
  }

  ngOnDestroy(): void {
    this.chatService.destroyConnection();
    this.subscription.unsubscribe();
  }
  handleEmergencyAlert() {
    this.alarmService.stopEmergencyAlertSound();
    this.router.navigate(['/emergency-alerts']);
  }
}
